<template>
  <b-modal ref="modalNouvelleCommande" size="xl" title="Créer une commande"
    no-close-on-backdrop
    @show="initialiserModale()"
    @shown="$refs.nomCommandeCreation.focus()">
    <template slot="default">
      <div class="container">
        <div class="form-group">
          <label for="nomCommande">Nom de la commande</label>
          <input class="form-control" type="text" id="nomCommande" ref="nomCommandeCreation" v-model.trim="optionsCreation.nom" maxlength="80" @focus="$event.target.select()">
          <div class="error" v-if="!$v.optionsCreation.nom.required">Ce champ est requis</div>
          <div class="error" v-if="!$v.optionsCreation.nom.minLength">Ce champ doit contenir au moins 3 caractères</div>
        </div>

        <div v-for="(param, iParam) in optionsCreation.parametreCreation" :key="iParam">
          <div class="card border-secondary" :key="key">
            <div class="card-header flex-center-space-between" :class="!param.dateDebut || !param.dateFin || !param.menusPlansIds.length || !param.servicesIds.length ? 'bg-danger' : ''">
              <span>{{ "Menus du " + ([ formatHumanDate(param.dateDebut), formatHumanDate(param.dateFin) ].filter(p => p).join(" au ") || "...") }}</span>
              <button type="button" class="btn btn-danger btn-sm" v-tooltip="{ content: 'Supprimer cette période de menus'}" @click="supprimerPeriode(iParam)">
                <i class="fas fa-trash"></i>
              </button>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <SelectDatesMenusPlansServices :multiLigne="true" :periodeMenus="param" :dateDebut="param.dateDebut" :dateFin="param.dateFin" :menuPlanIds="param.menusPlansIds" :serviceIds="param.servicesIds" viderMenusPlans="Vider" @changer-dms="changerParametresMenus(iParam, $event)" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-footer">
      <div class="flex-center-space-between w-100">
        <button type="button" class="btn btn-primary" :disabled="!estValide" v-tooltip="{ content: 'Ajouter une période de menus'}" @click="ajouterPeriode()">Ajouter une période de menus</button>
      <div>
        <button type="button" class="btn btn-secondary mr-2" @click="hide()">Annuler</button>
        <button type="button" class="btn btn-primary" :disabled="!$v.optionsCreation.nom.required || !$v.optionsCreation.nom.minLength || !estValide" @click="creerCommande()">Créer</button>
      </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { ajouterCommande } from '@/api/gpao/commandes'
import { connecteData } from "@/mixins/connecteData"
import { showAlerts } from '@/mixins/alerts'
import { required, minLength, maxLength } from "vuelidate/lib/validators"
import { formatageDate } from '@/mixins/dateFormats'
import SelectDatesMenusPlansServices from '@/components/Divers/SelectDatesMenusPlansServices'

export default {
  name: "ModalCreationCommande",
  mixins: [ connecteData, showAlerts, formatageDate ],
  props: [ "commande" ],
  components: {
    SelectDatesMenusPlansServices
  },
  data() {
    return {
      key: 1,
      optionsCreation: {},
      estValide: true
    }
  },
  validations: {
    optionsCreation: {
      nom: {
        required,
        minLength: minLength(3),
        maxlength: maxLength(80)
      }
    }
  },
  methods: {
    initialiserModale() {
      this.optionsCreation = {
        nom:"",
        parametreCreation : []
      }
      this.estValide = true
    },
    ajouterPeriode() {
      let param = { dateDebut: '', dateFin: '', menuPlansIds: null, servicesIds: null, depuisBesoins: 0 }
      this.optionsCreation.parametreCreation.push(param)
      this.estValide = false
    },
     supprimerPeriode(index) {
      this.optionsCreation.parametreCreation.splice(index, 1)
      this.estValide = true
    },
    changerParametresMenus(index, parametres) {
      this.optionsCreation.parametreCreation[index].dateDebut = parametres.dateDebut != "" ? parametres.dateDebut : null
      this.optionsCreation.parametreCreation[index].dateFin = parametres.dateFin != "" ? parametres.dateFin : null
      this.optionsCreation.parametreCreation[index].menusPlansIds = parametres.menuPlanIds
      this.optionsCreation.parametreCreation[index].servicesIds = parametres.serviceIds
      this.optionsCreation.parametreCreation[index].depuisBesoins = this.optionsCreation.parametreCreation[index].dateDebut && this.optionsCreation.parametreCreation[index].dateFin && this.optionsCreation.parametreCreation[index].menusPlansIds.length
 
      if(this.optionsCreation.parametreCreation[index].dateDebut && this.optionsCreation.parametreCreation[index].dateFin && this.optionsCreation.parametreCreation[index].menusPlansIds.length > 0 && this.optionsCreation.parametreCreation[index].servicesIds.length > 0)
        this.estValide = true
      else
        this.estValide = false
      this.key++
    },
    async creerCommande() {
      this.$store.commit('uxHelpers/showSpinner')
      let response = await ajouterCommande(this.etabCourantId, this.optionsCreation)
      this.hide()
      this.alerteSucces("Commande crée !")
      this.$emit("commande-creee", response.data)
      this.$store.commit('uxHelpers/hideSpinner')
    },
    show() {
      this.$refs.modalNouvelleCommande.show()
    },
    hide() {
      this.$refs.modalNouvelleCommande.hide()
    }
  }
}
</script>
